module.exports = __webpack_public_path__ + "static/media/outstation.9ddf9da2.png";